import { isEqual, isSameDay, isSameMonth, isSameYear, parseISO } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz';
import { enUS } from 'date-fns/locale';
/* Please note: Timezone is fixed to Europe/Paris to prevent issues internationally */
export default function() {
    const formats = {
        // Sun, Sep 26, 1:00PM
        long: 'EEE, d MMM, h:mmaa',
        dayMonth: 'EEE, d MMM',
        dayMonthYear: 'EEE, d MMM y',
        numericDate: 'dd-MM-y',
        day: 'd',
        time: 'h:mm aa'
    };
    const locale = enUS;

    function getDateRange(dateStart, dateEnd, formatDateYear = formats.dayMonthYear, formatDate = formats.dayMonth, formatTime = formats.time) {
        if (isEqual(dateStart, dateEnd)) {
            return formatInTimeZone(dateStart, 'Europe/Paris', formatDateYear, { locale });
        } else if (isSameDay(dateStart, dateEnd)) {
            return `${formatInTimeZone(dateStart, 'Europe/Paris', formatDateYear, { locale })} - ${formatInTimeZone(dateEnd, 'Europe/Paris', formatTime, { locale })}`;
        } else if (isSameMonth(dateStart, dateEnd) && isSameYear(dateStart, dateEnd)) {
            return `${formatInTimeZone(dateStart, 'Europe/Paris', formatDate, { locale })} - ${formatInTimeZone(dateEnd, 'Europe/Paris', formatDateYear, { locale })}`;
        } else {
            // start date + end date are different, not even the year is the same
            return `${formatInTimeZone(dateStart, 'Europe/Paris', formatDateYear, { locale })} - ${formatInTimeZone(dateEnd, 'Europe/Paris', formatDateYear, { locale })}`;
        }
    }

    function formatDateRange(startInput, endInput) {
        const dateStart = parseISO(startInput);

        if (endInput) {
            const dateEnd = parseISO(endInput);
            return getDateRange(dateStart, dateEnd);
        } else {
            return getDateRange(dateStart, dateStart);
        }
    }

    function formatSingleDate(input, dateFormat) {
        let parsedDate;
        if (typeof input === 'string') {
            parsedDate = parseISO(input);
        } else {
            parsedDate = input;
        }
        return formatInTimeZone(parsedDate, 'Europe/Paris', dateFormat ?? formats.long, { locale });
    }

    return { formats, getDateRange, formatDateRange, formatSingleDate };
}
